import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageComponent } from './image/image.component';
import { PreviewPdfComponent } from './preview-pdf/preview-pdf.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [
    ImageComponent,
    PreviewPdfComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
  ],
  exports: [
    ImageComponent,
    PreviewPdfComponent,
  ]
})
export class ComponentsModule { }
